module.exports = __webpack_public_path__ + "static/media/share.79e29a13.svg";